import React from 'react';

const cardKeys = [
  'payments_onboarding',
  'availability',
  'clients',
  'location',
  'appointments',
  'google_calendar',
  'setup_payments',
  'profile_photo',
  'gallery_image',
  'subscribe',
  'services',
] as const;
type OnboardingCarouselCardKeys = typeof cardKeys[number];

export interface IAbstractOnboardingCarouselCard {
  key: string;
  title: string | React.ReactNode;
  body: string | React.ReactNode;
  cta: string;
  backgroundColor?: string;
  onClick: () => void;
  onDismiss?: () => void;
  incompleteIcon?: string;
  completeIcon?: string;
  complete: boolean;
}

export interface IBackEndManagedOnboardingCarouselCard extends IAbstractOnboardingCarouselCard {
  key: OnboardingCarouselCardKeys;
}

export interface ISelfManagedOnboardingCarouselCard extends IAbstractOnboardingCarouselCard {
}

export function isBackEndManagedCard(
  card: IAbstractOnboardingCarouselCard,
): card is IBackEndManagedOnboardingCarouselCard {
  return cardKeys.includes(card.key as any);
}

export function isSelfManagedCard(
  card: IAbstractOnboardingCarouselCard,
): card is ISelfManagedOnboardingCarouselCard {
  return !cardKeys.includes(card.key as any) && typeof card.key === 'string';
}

export type IOnboardingCarouselContainerProps = {
  providerId: string | number;
  providerName: string;
  connectAccount?: () => void;
  editAvailability?: () => void;
  editServices?: () => void;
  addGalleryPhoto?: () => void;
  editBusinessInfo?: () => void;
};
